import { OrderSet } from "@models/OrderSet";

import { useOrderSetQuery } from "../../queries/orderSetQueries";
import {
  DraftOrderSetContext,
  getDraftOrderSetIdentity,
} from "../draftOrderSetIdentity";

type DraftOrderSetList = {
  data: OrderSet[];
  isFetching: boolean;
  isFetched: boolean;
};

/**
 * The draft order-set of an ordering context, and whether we still might find
 * one. A catalog learns the draft's id from a list of the user's drafts, then
 * loads the order-set itself, so it is loading while either step is.
 */
const useDraftOrderSetFromList = (
  list: DraftOrderSetList,
  context: DraftOrderSetContext
) => {
  const id = list.data.find(getDraftOrderSetIdentity(context).matches)?.id;
  const orderSetQuery = useOrderSetQuery(id);

  return {
    data: orderSetQuery.data,
    isLoading:
      orderSetQuery.isLoading ||
      (list.isFetching && !list.isFetched && !orderSetQuery.data),
  };
};

export default useDraftOrderSetFromList;
